/**
 * Simple FRVR shareMessage payload for game-over score brag.
 * The image is the cartoon brag card (render/toon/overlays/share-card.js), drawn in code.
 */
import { drawShareCard } from "../render/toon/overlays/share-card.js";

/**
 * @param {{ score?: number, bestScore?: number }} params
 * @returns {{ headline: string, text: string, image: string, cta: string }}
 */
export function buildGameOverSharePayload(params) {
  var opts = params || {};
  var score = Math.max(0, Math.floor(Number(opts.score) || 0));
  var best = Math.max(score, Math.floor(Number(opts.bestScore) || 0));

  var canvas = document.createElement("canvas");
  canvas.width = 320;
  canvas.height = 180;
  var ctx = null;
  try {
    ctx = canvas.getContext("2d");
  } catch (e) {
    ctx = null;
  }
  if (ctx) {
    try {
      drawShareCard(ctx, 320, 180, { score: score, best: best });
    } catch (e) {
      // A failed drawing must not block the share itself; it just goes without a picture.
      ctx = null;
    }
  }

  var image = null;
  if (ctx && typeof canvas.toDataURL === "function") {
    try {
      image = canvas.toDataURL("image/png");
    } catch (e) {
      image = null;
    }
  }

  return {
    headline: "Catch'n'Merge",
    text: "I scored " + score + "! Can you beat my best of " + best + "?",
    image: image,
    cta: "Play now",
  };
}
